// src/constants/areas.js
const AREAS = [
  "Vision Infra (Arsha)",
  "Rajapushpa (Imperia)",
  "Rajapushpa (Ceyond/Sirendler)",
  "Aparna (Cyber Highites)",
  "Nesti Qualitas",
  "The Raghava",
  "Aparna (Cyber Sign)",
  "Aparna (Cyber Star)",
  "Aparna (Cyber On)",
  "Space Station - Aliens",
  "My Home (Avani)",
  "My Home (Ankura)",
  "My Home (Sayuk)",
  "DSR (Park Ridge)",
  "Mayfair Villas",
  "Tripura Galaxy",
  "BDL Friends Residency (Tripura)",
  "NCC Cyber Urbania",
  "Honeri Aquantis",
  "Bricks Skywood",
  "Pristine Estates Villas",
  "Aditya Eden Woods Villas",
  "My Home (Tridesa)",
  "Rajapushpa (Green Dale)",
  "Kakatiya Infra (Mango Leaf)",
  "Magnas Majestic Meadows",
  "Praneeth Jagganthi (Elite)",
  "Aditya Eden Wood Villas",
  "Divino Villas",
  "Esta",
  "Aakriti (Honey Dew)",
  "Mayfair (Green Mark)",
  "Arbour (Bonsai Housing)",
  "Aditya Eden (Arbregade)",
  "Essen Elegance",
  "Aparna (Cyber Commune)",
  "Aparna (Cyber Zon)",
  "Trishala (Saffron Sanathban)",
  "Aparna (Cyber Life)",
  "Hima Sai (Lake View Towers)",
  "Aparna (Sarovar Zenith)",
  "Aparna (Sarovar Grande)",
  "Aparna (Sarovar)",
  "Aparna (Cyber County) Villas",
  "Aakriti (Mira)",
  "Ramky One Galaxia",
  "Aashraya (Green Homes)",
  "Aakriti (ARV Viva)",
  "The Peach Villas",
  "Indus Crest (Gated)",
  "Harmi Nirvana (Gated)",
  "Tudor Ken Villas",
  "Cyber Woods (Gated)",
  "Ananda Homes (The Ozone Heights)",
  "Rajapushpa Lifestyle City",
  "Vajith Villas",
  "Aakriti CRR Lakeside Villas",
  "Nivee Gardens Villas",
  "Vajram (Aster Homes)",
  "Manjeera Casa",
  "Amogha Home",
  "Manjeera Purple Town",
  "Honeri Homes (Uivantis)",
  "Vision Infiniti Homes Villas",
];

export default AREAS;
